import {FC} from 'react'
import {ConnectorNamesE} from '../../services/moengage.model'
import PopupConnector, {PopupConnectorProps} from './popup-connector/PopupConnector'
import CardConnector from './card-connector/CardConnector'

export const connectorsList: {[key: string]: FC<PopupConnectorProps>} = {
    [ConnectorNamesE.popup]: PopupConnector,
    [ConnectorNamesE.card]: CardConnector
}
